import { render } from "./buttonComponent.vue?vue&type=template&id=4292985c&ts=true"
import script from "./buttonComponent?vue&type=script&lang=ts"
export * from "./buttonComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__